<template>
    <section class="publication">
        <div class="container">

            <div class="row">
                <div class="col-md-12">
                    <div class="publication__heading d-flex">
                        <publication-progress :step-info="{info: { step: 1, title: $store.getters.t('publication_create_choose_ad_type') }, count: 1}"/>

                        <h2 v-if="currentStepComponent">{{$store.getters.t(currentStepComponent.title)}}</h2>
                        <h2 v-else>{{$store.getters.t('publication_create_who_to_add')}}</h2>
                    </div>
                </div>
            </div>

            <div class="publication__content">
                <div class="row">
                    <div class="col-md-12">
                        <div class="publication__slider" ref="slider">

                            <div class="publication__slider-track clearfix" :style="{width: `${trackWidth}px`, transform: `translateX(${trackTransform}px)`}">

                                <div class="publication__slider-slide" :style="{width: `${slideWidth}px`}">
                                    <div class="publication__cards content-width d-flex">
                                        <div class="publication__card  d-flex" :class="{'publication__card--selected': _item.key === selected }"
                                             v-for="(_item, _idx) in initial">

                                            <div class="publication__card-left">
                                                <div class="publication__card-header  d-flex">
                                                    <img :src="_item.icon" class="publication__card-icon" alt="" v-if="_item.icon">
                                                    <h3 class="publication__card-title">{{$store.getters.t(_item.title)}}</h3>
                                                </div>

                                                <div class="publication__card-description">{{$store.getters.t(_item.description)}}</div>
                                            </div>
                                            <div class="publication__card-right d-flex">
                                                <a :href="_item.link" @click="handleSelected()" class="btn publication__btn" v-if="_item.link">{{$store.getters.t('common_choose')}}</a>
                                                <a href="#" @click.prevent="handleSelected(_item.key)" class="btn publication__btn"
                                                   v-if="_item.steps && _item.steps.length && selected !== _item.key">{{$store.getters.t('common_choose')}}</a>
                                                <a href="#" @click.prevent="handleSelected()"
                                                   class="btn publication__btn publication__btn--selected" v-if="selected === _item.key">{{$store.getters.t('common_cancel')}}</a>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <template v-if="selected && initial[selected].steps && initial[selected].steps.length">

                                    <template v-for="(s, idx) in initial[selected].steps">

                                        <div class="publication__slider-slide" :style="{width: `${slideWidth}px`}" :key="idx">
                                            <div class="publication__cards content-width d-flex">
                                                <component :is="s.component.name"></component>
                                            </div>
                                        </div>

                                    </template>

                                </template>


                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <div class="publication__nav d-flex">
                        <button type="button" class="btn publication__btn" v-if="step >= 1"
                                @click.prevent="handleTransform('decrement')"
                                >{{$store.getters.t('common_back')}}</button>
                        <button type="button" class="btn publication__btn publication__btn--primary"
                                @click.prevent="handleTransform('increment')"
                                :disabled="!selected">{{$store.getters.t('common_forward')}}</button>
                    </div>
                </div>
            </div>

        </div>
    </section>
</template>

<script>

import {paginationScrollTo} from "../helpers/helpers";

const startCreate = {
    pets:       {
        key: 'pets',
        title: 'publication_create_card_pets_title',
        icon: '/assets/images/icons/publication-pet.svg',
        description: 'publication_create_card_pets_desc',
        link: '/publication/pet',
    },
    projects:   {
        key: 'projects',
        title: 'publication_create_card_projects_title',
        icon: '/assets/images/icons/publication-project.svg',
        description: 'publication_create_card_projects_desc',
        link: '/publication/project',
    },
    personal:   {
        key: 'personal',
        title: 'publication_create_card_personal_title',
        icon: '/assets/images/icons/publication-personal.svg',
        description: 'publication_create_card_personal_desc',
        link: '/publication/personal_pet',
    },
    facilities: {
        key: 'facilities',
        title: 'publication_create_card_facilities_title',
        icon: '/assets/images/icons/publication-facility.svg',
        description: 'publication_create_card_facilities_desc',
        steps: [{ title: 'publication_create_choose_ad_type', component: PublicationCreateFacilities  }]
    }
}

import StateMixin from "./mixins/StateMixin";

import PublicationProgress from './PublicationProgress';
import PublicationCreateFacilities from  './PublicationCreateFacilities';

export default {
    name: "PublicationCreate",
    components: { PublicationProgress, PublicationCreateFacilities },
    props: ['server'],
    mixins: [StateMixin],
    data(){
        return{
            step: 0,
            selected: null,
            slideWidth: 0,
            trackWidth: 0,
            trackTransform: 0,
            windowInnerWidth: 0,
        }
    },

    created(){
        this.handleWindowInnerWidth();
        this.CREATE_STATE_BY_KEY('empty');
        this.SET_PUBLICATION_TYPE(null);

        window.addEventListener('resize', this.handleWindowInnerWidth)
    },

    mounted() {
    },

    destroyed(){
        window.removeEventListener('resize', this.handleWindowInnerWidth);
    },

    computed: {

        initial()     { return startCreate },

        currentStepComponent() {
            if ( ( ! this.selected  || ! this.initial[ `${this.selected}` ].steps?.length ) && this.step === 0 ) return;

            let component = this.initial[ `${this.selected}` ].steps[ this.step - 1 ];
            return  component;

        },


    },

    watch:{

        windowInnerWidth( _current, _previous ){

            if ( _current === _previous ) return;

            new Promise( res => {
                this.handleSlideWidth();
                res();
            } ).then( () => {
                this.handleSelected( this.selected );
                this.trackTransform = `-${(this.slideWidth + 30) * this.step}`;
            } )

        }

    },

    methods:{

        handleWindowInnerWidth(){
            this.windowInnerWidth = window.innerWidth
        },

        handleTransform( type ){
            if( ! this.selected ) return;

            if( type === 'increment' ){

                if( this.step + 1 >= this.initial[ `${this.selected}` ].steps.length + 1 ) return;

                this.step = this.selected ? ++this.step : this.step;

            }

            if( type === 'decrement' ){
                this.step = this.selected ? --this.step : 0;
            }


            paginationScrollTo('.publication__heading');

            setTimeout( () => {
                this.trackTransform = `-${(this.slideWidth + 30) * this.step}`;
            }, 700 )

        },

        handleSlideWidth(){
            if( this.$refs.slider )
                this.slideWidth = this.$refs.slider.clientWidth;
        },

        handleSelected( val = null ){
            this.selected = val;

            if( ! this.selected ){
                return this.trackWidth = this.slideWidth;
            }

            this.trackWidth = ( ( this.initial[ `${this.selected}` ].steps.length + 1 ) * ( this.slideWidth + 30 ) );
        }

    }

}
</script>

<style lang="scss">

.publication__progress-loader{
    width: 40px;
}

</style>
